import React from 'react';

import styles from './Story.module.scss'
import Divider from '../Divider/Divider';
import Card from '../Card/Card';

const Story = ({className = '', storyPoints}) => {
    return (
        <Card className={`${styles.storyContainer} ${className}`}>
            {storyPoints.map((item, index) => (
                <div key={`story-${index}`}>
                    <div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                    {index + 1 < storyPoints.length && <Divider vertical className={styles.line} />}
                </div>
            ))}
            
        </Card>
    )
}

export default Story;